import { render, staticRenderFns } from "./StudioMemberChip.vue?vue&type=template&id=ef901c3a&scoped=true"
import script from "./StudioMemberChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudioMemberChip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StudioMemberChip.vue?vue&type=style&index=0&id=ef901c3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef901c3a",
  null
  
)

export default component.exports